module.exports = __webpack_public_path__ + "img/pie-chart.f4689685.png";